import { bootstrapApplication } from '@angular/platform-browser';
import {RouteReuseStrategy, provideRouter, withPreloading, PreloadAllModules} from '@angular/router';
import { IonicRouteStrategy, provideIonicAngular } from '@ionic/angular/standalone';

import { routes } from './app/app.routes';
import { AppComponent } from './app/app.component';
import { environment } from './environments/environment.prod';

import { API_BASE_ENDPOINT, ApiBaseInterceptor } from './app/interceptors/api-base.interceptor';
import { API_TOKEN_VALUE, ApiKeyInterceptor } from './app/interceptors/api-key.interceptor';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { importProvidersFrom } from '@angular/core';

import { TranslateModule, TranslateLoader } from "@ngx-translate/core";
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { HttpClient } from '@angular/common/http';

const httpLoaderFactory: (http: HttpClient) => TranslateHttpLoader = (http: HttpClient) =>
  new TranslateHttpLoader(http, './assets/i18n/', '.json');

bootstrapApplication(AppComponent, {
  providers: [
    {
      provide: RouteReuseStrategy,
      useClass: IonicRouteStrategy
    },
    provideIonicAngular(),
    provideRouter(routes,
        withPreloading(PreloadAllModules),
    ),
    provideHttpClient(
      withInterceptors([
        ApiBaseInterceptor,
        ApiKeyInterceptor
      ])),

    importProvidersFrom([TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: httpLoaderFactory,
        deps: [HttpClient],
      },
    })]),

    {
      provide: API_BASE_ENDPOINT,
      useValue: environment.APIEndPoint
    },
    {
      provide: API_TOKEN_VALUE,
      useValue: environment.APITokenValue
    },
  ],
});
